import { NavigationSection } from "@/types/navigation";
import { BaseService } from "./base.service";

class NavigationService extends BaseService {
  constructor() {
    super("/navigation");
  }

  async getNavigation() {
    return this.get<NavigationSection[]>();
  }
}

export const navigationService = new NavigationService();
